import { AnyEvent, ClickOutsideListener } from './ClickOutsideGlobal';
import { isDOMElementContainsTarget } from './isDOMElementContainsTarget';
import { isShadowDOMElementContainsTarget } from './isShadowDOMElementContainsTarget';
import React from 'react';

const clickOutside = (() => {
  let instance: ClickOutsideListener;

  return () => {
    if (!instance) {
      instance = new ClickOutsideListener();
    }

    return instance;
  };
})();

export function useOnClickOutside<T extends HTMLElement = HTMLDivElement>(
  handler: (event: AnyEvent) => void,
): React.RefObject<T> {
  const ref = React.useRef<T>(null);

  React.useEffect(() => {
    const listener = (event: AnyEvent) => {
      const el = ref?.current;

      if (
        !el ||
        isDOMElementContainsTarget(el, event) ||
        isShadowDOMElementContainsTarget(el, event)
      ) {
        return;
      }

      handler(event);
    };

    clickOutside().on(listener);

    return () => clickOutside().off(listener);
  }, [ref, handler]);

  return ref;
}
